<template>
  <div class="webble-inline-html-editor" v-if="inlineMode">
    <div ref="editableContent" class="editable-content" v-html="html" contenteditable="true"></div>
  </div>
  <div v-else v-html="html"></div>
</template>

<script>
export default {
  name: 'InlineHtmlEditor',
  props: {
    html: {
      type: String,
      required: true
    }
  },
  computed: {
    inlineMode() {
      return this.isLoggedIn && this.currentUser.mode == 'inline'
    }
  }
}
</script>
